import '../index.css'
import * as React from 'react'
import validation from 'react-validation-mixin'
import strategy from 'react-validatorjs-strategy'
import scrollIntoView from 'scroll-into-view-if-needed'
import type { ImageProps } from 'types/content-editor'
import type { ValidationProps } from 'types/validation'
import { updateImageProp } from '@disco/content-editor/prop-utils'
import { fixLink, LINK_VALIDATOR, validateLink } from '@disco/utils/links'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import ImagePropsView from './view'

class ImageSettings extends React.Component<
  {
    value: ImageProps
    csrfToken: string
    maxImageWidth?: number
    onSubmit: (form: Record<string, any>) => unknown
    onCancel: () => unknown
  } & ValidationProps,
  {
    value: Record<string, any>
    imageUploading: boolean
  }
> {
  _paneRef: HTMLDivElement | null | undefined
  validatorTypes = strategy.createSchema(
    {
      link: 'LINK_VALIDATOR',
      location: 'url',
    },
    {
      [LINK_VALIDATOR]: 'The url format is invalid.',
    },
    validator => {
      validator.constructor.register('LINK_VALIDATOR', validateLink)
    },
  )
  getValidatorData = () => {
    return {
      location: this.state.value.src,
      link: this.state.value.link,
    }
  }
  state = {
    value: this.props.value,
    imageUploading: false,
  }
  _handleSubmit = () =>
    this.props.validate(error => {
      if (!error) {
        this.props.onSubmit(this.state.value)
      } else {
        if (!this._paneRef) return

        const errorItems = this._paneRef.getElementsByClassName('label__error')

        const focusedItem = errorItems[0]

        if (focusedItem) {
          scrollIntoView(focusedItem, {
            behavior: 'smooth',
            scrollMode: 'if-needed',
            boundary: this._paneRef,
          })
        }
      }
    })
  _onChange = (e: React.ChangeEvent<any>) => {
    const value = updateImageProp(
      this.state.value,
      e.target.name,
      e.target.name === 'src' || e.target.name === 'link'
        ? fixLink(e.target.value)
        : e.target.value,
      this.props.maxImageWidth,
    )
    this.setState({
      value,
      imageUploading: false,
    })
  }
  _onImageSet = (value: ImageProps) => {
    this.setState({
      value: { ...this.state.value, ...value },
    })
    if (value.width)
      this.setState({
        imageUploading: false,
      })
  }
  _onImageUpload = () =>
    this.setState({
      imageUploading: true,
    })

  render() {
    return (
      <div className="rich-text-toolbar__settings">
        <h3 className="rich-text-toolbar__settings__header">Image settings</h3>
        <div
          className="rich-text-toolbar__settings__body"
          ref={r => {
            this._paneRef = r
          }}
        >
          <ImagePropsView
            className="rich-text-toolbar__settings__list"
            value={this.state.value}
            maxImageWidth={this.props.maxImageWidth}
            onChange={this._onChange}
            onImageSet={this._onImageSet}
            onImageUpload={this._onImageUpload}
            validationErrors={{
              src: this.props.getValidationMessages('location').toString(),
              link: this.props.getValidationMessages('link').toString(),
            }}
          />
          <ButtonContainer>
            <Button
              appearance="primary"
              caption="Apply"
              disabled={this.state.imageUploading}
              onClick={this._handleSubmit}
            />
            <Button caption="Cancel" onClick={this.props.onCancel} />
          </ButtonContainer>
        </div>
      </div>
    )
  }
}

export default validation(strategy)(ImageSettings) as any
